module.exports = __webpack_public_path__ + "img/footLogo.747adfdf.png";